import React from 'react';

import { t } from '../../services/i18nService';
import viewReadyTracker from '../../services/ViewReadyTracker';
import styles from './UnsupportedViewportPage.scss';

class UnsupportedViewportPage extends React.PureComponent {
    componentDidMount() {
        viewReadyTracker.reportReady(true, viewReadyTracker.pathname);
        if (this.dialogRef) {
            this.dialogRef.focus();
        }
    }

    render() {
        return (
            <div className={styles.overlay} role="presentation">
                <div
                    className={styles.modal}
                    role="alertdialog"
                    aria-modal="true"
                    aria-labelledby="unsupported-viewport-title"
                    aria-describedby="unsupported-viewport-body"
                    tabIndex="-1"
                    ref={(el) => { this.dialogRef = el; }}
                >
                    <div className={styles.header}>
                        <i className={`fa fa-exclamation-circle ${styles.icon}`} aria-hidden="true" />
                        <h2 id="unsupported-viewport-title" className={styles.title}>{t('viewportRequirement.unsupported.title')}</h2>
                    </div>
                    <div id="unsupported-viewport-body" className={styles.body}>{t('viewportRequirement.unsupported.body')}</div>
                </div>
            </div>
        );
    }
}

export default UnsupportedViewportPage;
